export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    LOGOUT: '/auth/logout',
    CURRENT_USER: '/profile',
    REFRESH: '/auth/refresh',
  },
  USER: {
    PROFILE: '/profile',
    UPDATE: '/users',
  },
  EQUIPMENT: {
    ALL: '/equipments',
    GET: '/equipments',
    CREATE: '/equipments',
    UPDATE: '/equipments',
    DELETE: '/equipments',
    UPLOAD_IMAGES: '/equipments/:id/images',
    DELETE_IMAGE: '/equipments/:id/images/:imageId',
    REORDER_IMAGES: '/equipments/:id/images/reorder',
  },
  EQUIPMENT_CATEGORY: {
    ALL: '/equipment-categories',
    ALL_WITH_COUNT: '/equipment-categories/with-count',
    GET: '/equipment-categories/:id',
    CREATE: '/equipment-categories',
    UPDATE: '/equipment-categories/:id',
    DELETE: '/equipment-categories/:id',
  },
  RESERVATIONS: {
    CREATE: '/reservations',
    ME: '/reservations/me',
    GET: '/reservations',
    GET_BY_CODE: '/reservations/code/:code',
    CANCEL: '/reservations/:id/cancel',
    REPORT_ISSUE: '/reservations/:id/report-issue',
    AVAILABILITY: '/reservations/availability',
  },
  ADMIN: {
    RESERVATIONS: {
      GET: '/admin/reservations',
      CONFIRM: '/admin/reservations/:id/confirm',
      CANCEL: '/admin/reservations/:id/cancel',
      START_PREPARATION: '/admin/reservations/:id/start-preparation',
      MARK_DELIVERED: '/admin/reservations/:id/mark-delivered',
      MARK_ACTIVED: '/admin/reservations/:id/mark-active',
      MARK_PENDING_RETURN: '/admin/reservations/:id/mark-pending-return',
      MARK_IN_RETURN: '/admin/reservations/:id/mark-in-return',
      MARK_RETURNED: '/admin/reservations/:id/mark-returned',
      COMPLETE: '/admin/reservations/:id/complete',
    }
  }
} as const;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  TOKEN_EXPIRES_AT: 'token_expires_at',
} as const;

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu internet.',
  UNAUTHORIZED: 'Sesión expirada. Por favor, inicia sesión nuevamente.',
  VALIDATION_ERROR: 'Por favor, verifica los datos ingresados.',
  GENERIC_ERROR: 'Ha ocurrido un error inesperado.',
} as const;

export const ERROR_FALLBACK = 'Ha ocurrido un error inesperado.';

export const ERROR_TEXTS: Record<string, string> = {
  'AUTH.INVALID_CREDENTIALS': 'Credenciales inválidas. Verifica email y contraseña.',
  'AUTH.TOKEN_REQUIRED': 'Se requiere autenticación para realizar esta acción.',
  'AUTH.TOKEN_INVALID': 'Token inválido. Vuelve a iniciar sesión.',
  'AUTH.TOKEN_EXPIRED': 'La sesión expiró. Por favor inicia sesión de nuevo.',
  'AUTH.TOKEN_INVALID_TYPE': 'Tipo de token inválido.',
  'AUTH.ACCOUNT_DISABLED': 'La cuenta está deshabilitada. Contacta al soporte.',
  'AUTH.EMAIL_NOT_VERIFIED': 'El correo no ha sido verificado.',
  'AUTH.AUTHENTICATION_FAILED': 'Fallo de autenticación.',
  'AUTH.VALIDATION_FAILED': 'La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un número.',
  'COMMON.VALIDATION_FAILED': 'Error de validación. Revisa los campos.',
  'COMMON.BAD_REQUEST': 'Solicitud incorrecta.',
  'COMMON.ACCESS_DENIED': 'Acceso denegado.',
  'COMMON.RESOURCE_NOT_FOUND': 'Recurso no encontrado.',
  'COMMON.RATE_LIMIT_EXCEEDED': 'Se excedió el límite de peticiones. Intenta más tarde.',
  'COMMON.INTERNAL_ERROR': 'Error interno del servidor.',
  'USER.NOT_FOUND': 'Usuario no encontrado.',
  'USER.VALIDATION_FAILED': 'Validación de usuario fallida.',
  'EQUIPMENT.NOT_FOUND': 'Equipo no encontrado.',
  'EQUIPMENT.VALIDATION_FAILED': 'Validación de equipo fallida.',
  'RESERVATION.NOT_FOUND': 'Reserva no encontrada.',
  'RESERVATION.INVALID_STATE': 'Estado de reserva inválido para esta operación.',
  'RESERVATION.OVERLAP_CONFLICT': 'Existe un solapamiento con otra reserva.',
  'RESERVATION.INVALID_TRANSITION': 'Transición de estado inválida.',
  'RESERVATION.VALIDATION_FAILED': 'Validación de reserva fallida.',
};
